import { ISimpleUserRole, IUserGraph } from "@/models";

import { BaseRepository } from "@/repositories";

class SimpleValidatorRepository extends BaseRepository<ISimpleUserRole> {
    protected getAllErrorMessage = "Validators cannot be retrieved.";

    protected getOneErrorMessage = "This Validator cannot be retrieved.";

    protected addErrorMessage = "This Validator cannot be created, please verify fields.";

    protected updateErrorMessage = "This Validator cannot be updated, please verify fields.";

    protected removeErrorMessage = "This Validator cannot be removed.";

    constructor() {
        super("/simple/validators");
    }

    async importValidators(appCode: string, validatorsFile: File): Promise<ISimpleUserRole[]> {
        const formData = new FormData();
        formData.append("validatorsFile", validatorsFile);

        return await this.put(`/${appCode}/import`, formData, "multipart/form-data");
    }

    async setValidators(appCode: string, entityId: number | null, users: IUserGraph[]): Promise<ISimpleUserRole[]> {
        return await this.put(`/${appCode}`, {
            entityId,
            users,
        });
    }
}

const simpleValidatorRepository = new SimpleValidatorRepository();

export { SimpleValidatorRepository, simpleValidatorRepository };
